import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=33023470&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=33023470&lang=scss"
import style1 from "./shopList.vue?vue&type=style&index=1&id=33023470&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33023470",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33023470')) {
      api.createRecord('33023470', component.options)
    } else {
      api.reload('33023470', component.options)
    }
    module.hot.accept("./shopList.vue?vue&type=template&id=33023470&scoped=true", function () {
      api.rerender('33023470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowShopManagement/shopList/shopList.vue"
export default component.exports